module.exports = __webpack_public_path__ + "static/media/icon-bounce.7149376d.png";